import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    Department,
    Employee
} from '../../models/models';

@Component({
    selector: 'employee-form',
    templateUrl: './employee-form.component.html',
    standalone: false
})
export class EmployeeForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: Employee = {} as Employee;
    public departmentList: Department[] = [];
    public managerList: Employee[] = [];

    constructor(private employeeService: EmployeeService,
        private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        //console.log("ngOnChanges", this.tableID, this.carrierID);
        this.getDepartments();
        this.getManagers();
    }

    private getManagers() {
        this.employeeService.getActiveEmployees().subscribe(result => {
            this.managerList = result;
            this.managerList = this.managerList.filter(t => t.activeInd == true);
        });
    }

    private getDepartments() {
        this.employeeService.getDepartments().subscribe(result => {
            this.departmentList = result.resultCollection;
            this.getTableItem();
        });
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.employeeService.getEmployeeById(this.tableID).subscribe(result => {
                if (result != null) {
                    this.tableItem = result;
                    if (this.tableItem.startDate != null) {
                        this.tableItem.startDate = new Date(this.tableItem.startDate);
                    }
                    if (this.tableItem.endDate != null) {
                        this.tableItem.endDate = new Date(this.tableItem.endDate);
                    }
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            // Fields NOT to use:
            // BranchId, ParentBranchId, TrackingEmployeeId, fax, ERPOpsRepName, ERPAccountManagerName
            this.tableItem = {
                employeeId: 0,
                firstName: "",
                lastName: "",
                title: "",
                erpUserId: "",
                webId: "",
                winUserName: "",
                activeInd: true,
                email: "",
                phone: "",
                phoneExt: "",
                cell: "",
                fax: "",
                startDate: new Date(),
                //endDate: new Date(),
                departmentId: 1,
                branchId: 1,
                trackingEmployeeId: 0,
                erpOpsRepName: "",
                erpAccountManagerName: "",
                managerId: 0,
                managerInd: false,
                fullName: ""
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.employeeService.saveEmployee(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as Employee;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
